import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

function OrderConfirm() {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const errorMessage = new URLSearchParams(location.search).get(
    'error_message',
  );
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (params.orderResult == 'fail') {
      if (params.isFailed && params.isFailed == 'TS21')
        alert(
          'The card is not registered with the 3DS. Please contact your card company or issuing bank branch.',
        );
      else alert(new URLSearchParams(location.search).get('error_message'));
      let url = sessionStorage.getItem('lastOrderPageUrl');
      if (url) navigate(url);
      else navigate('/');
    } else if (params.orderResult == 'success') {
      sessionStorage.removeItem('temporaryOrderInfo');
      navigate(`/orderComplete/${params.orderNumber}`);
    }
  }, []);
  return <div></div>;
}
export default OrderConfirm;
